import CodeView from 'src/components/CodeView';
import absoluteSingle from 'src/examples/CSS/Position/absoluteSingle';
import absoluteTop from 'src/examples/CSS/Position/absoluteTop';
import absoluteRight from 'src/examples/CSS/Position/absoluteRight';
import absoluteBottom from 'src/examples/CSS/Position/absoluteBottom';
import absoluteLeft from 'src/examples/CSS/Position/absoluteLeft';
import absoluteCenter from 'src/examples/CSS/Position/absoluteCenter';
import absoluteMixed from 'src/examples/CSS/Position/absoluteMixed';
import fixed from 'src/examples/CSS/Position/fixed';
import * as React from 'react';
export default {
  CodeView,
  absoluteSingle,
  absoluteTop,
  absoluteRight,
  absoluteBottom,
  absoluteLeft,
  absoluteCenter,
  absoluteMixed,
  fixed,
  React
};